if (!customElements.get('mm-desktop-gallery')) {
  customElements.define('mm-desktop-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.viewport = this.querySelector('.mm-desktop-gallery__viewport');
      this.slides = [...this.querySelectorAll('.mm-desktop-gallery__slide')];
      this.thumbs = [...this.querySelectorAll('.mm-desktop-gallery__thumb')];
      this.status = this.querySelector('.mm-desktop-gallery__status');
      this.mediaContainer = this.closest('.product-area__media');
      this.productArea = this.closest('.product-area');
      if (!this.viewport || !this.slides.length || !this.mediaContainer) return;
      this.desktop = window.matchMedia('(min-width: 1000px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.activeIndex = -1;
      this.frame = null;
      const activate = () => {
        this.mediaContainer.classList.toggle('mm-desktop-gallery-ready', this.desktop.matches);
        if (this.desktop.matches) this.updateActive();
      };
      this.desktop.addEventListener('change', activate, { signal });
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => this.goTo(thumb.dataset.mmTarget), { signal });
        thumb.addEventListener('keydown', (event) => {
          let next = index;
          if (event.key === 'ArrowDown') next = Math.min(index + 1, this.thumbs.length - 1);
          else if (event.key === 'ArrowUp') next = Math.max(index - 1, 0);
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.thumbs.length - 1;
          else return;
          event.preventDefault();
          this.thumbs[next].focus({ preventScroll: true });
          this.goTo(this.thumbs[next].dataset.mmTarget);
        }, { signal });
      });
      const schedule = () => {
        if (!this.desktop.matches || this.frame !== null) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateActive();
        });
      };
      this.viewport.addEventListener('scroll', schedule, { passive: true, signal });
      window.addEventListener('resize', schedule, { passive: true, signal });
      if (this.productArea) {
        this.productArea.addEventListener('on:variant:change', (event) => {
          if (!this.desktop.matches) return;
          const imageId = event.detail?.variant?.featured_media?.id;
          if (imageId) this.goTo(String(imageId));
        }, { signal });
      }
      activate();
    }
    goTo(imageId) {
      if (!this.desktop?.matches) return;
      const slide = this.slides.find((item) => item.dataset.mmImage === String(imageId));
      if (!slide) return;
      const top = this.viewport.scrollTop + slide.getBoundingClientRect().top - this.viewport.getBoundingClientRect().top;
      this.viewport.scrollTo({ top, behavior: this.reducedMotion.matches ? 'instant' : 'smooth' });
    }
    updateActive() {
      const offset = this.viewport.getBoundingClientRect().top + 12;
      let index = 0;
      this.slides.forEach((slide, slideIndex) => {
        if (slide.getBoundingClientRect().top <= offset) index = slideIndex;
      });
      if (index === this.activeIndex) return;
      this.activeIndex = index;
      this.thumbs.forEach((thumb, thumbIndex) => {
        if (thumbIndex === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      const rail = this.querySelector('.mm-desktop-gallery__rail');
      const thumb = this.thumbs[index];
      if (rail && thumb) {
        const railRect = rail.getBoundingClientRect();
        const thumbRect = thumb.getBoundingClientRect();
        if (thumbRect.top < railRect.top) rail.scrollTop -= railRect.top - thumbRect.top;
        else if (thumbRect.bottom > railRect.bottom) rail.scrollTop += thumbRect.bottom - railRect.bottom;
      }
      if (this.status) this.status.textContent = `Photo ${index + 1} of ${this.slides.length}`;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      if (this.frame !== null) cancelAnimationFrame(this.frame);
      this.mediaContainer?.classList.remove('mm-desktop-gallery-ready');
    }
  });
}
